import { instance as axios } from './baseUrl'

export const contact = (values) => axios.post('/email', { ...values })